import Head from 'expo-router/head';

export type SeoProps = {
  title: string;
  description?: string;
  ogImage?: string;
  /** Resolved URL of the page's LCP image, emitted as <link rel="preload">. */
  preloadImage?: string;
};

// Rendered through expo-router/head so the tags are serialized into the
// statically exported HTML (and kept in sync on client navigation).
export function SeoHead({ title, description, ogImage, preloadImage }: SeoProps) {
  const fullTitle = `${title} · Zoukessence`;
  return (
    <Head>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="de_CH" />
      <meta property="og:site_name" content="Zoukessence" />
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      <meta name="twitter:card" content={ogImage ? 'summary_large_image' : 'summary'} />
      {preloadImage ? <link rel="preload" as="image" href={preloadImage} /> : null}
    </Head>
  );
}
